import { FlowDurationUnits, FlowExportMode, FlowFormV2Mode } from 'flow-schema';

import { api } from 'common';

import { FormV2BlockFormFields } from './FormFields';
import { formV2BlockDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';
import { getDefaultSchedulingConfigs } from '../Form/SchedulingConfigs/utils';

export const formV2Config: BlockConfigProps<api.FlowDefinition.FormV2Block['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'form',
  defaultConfig: {
    formTemplateConfigs: [],
    schedulingConfigs: getDefaultSchedulingConfigs(),
    isOverridingEntity: false,
    exportMode: FlowExportMode.RunAutoExport,
    mode: FlowFormV2Mode.AddAndWaitForCompletion,
    timeout: {
      value: 1,
      units: FlowDurationUnits.Days,
    },
    notificationSchemeIdOverride: null,
  },
  configFields: {
    schema: api.FlowDefinition.FormV2BlockConfigSchema,
    FormFields: FormV2BlockFormFields,
  },
  documentationMarkdown: formV2BlockDocumentationMarkdown,
};
